import React, {FC} from 'react'

import cn from 'classnames/bind'

import {Col, Container, Row} from 'components/elements/grid'
import {IInvoiceContent} from 'pages/invoice-generator'

import s from './InvoiceUsers.module.scss'
import LandingsTitle from '../../LandingsTitle/LandingsTitle'
const cx = cn.bind(s)

interface IInvoiceUsersProps {
	className?: string
	content: IInvoiceContent['users']
}

/** InvoiceUsers block component */
const InvoiceUsers: FC<IInvoiceUsersProps> = ({className, content}) => {
	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<LandingsTitle title={content?.title} />
				<Row>
					<Col xl={{span: 10, offset: 1}}>
						<ul className={s.list}>
							{content?.items?.map((item) => (
								<li className={s.item} key={item._key || item.title}>
									<h3 className={cx('h3', 'item__title')}>{item.title}</h3>
									<p className={cx('item__text')}>{item.description}</p>
								</li>
							))}
						</ul>
					</Col>
				</Row>
			</Container>
		</div>
	)
}

InvoiceUsers.displayName = 'InvoiceUsers'

export default InvoiceUsers
